<div
  class="table"
  [class.table--rounded-bottom]="!isPaginatorVisible()"
  [class.table--border-bottom]="isPaginatorVisible()">
  <p-table
    #table
    dataKey="id"
    [rows]="DEFAULT_PAGE_SIZE"
    [rowHover]="rowHover()"
    [showCurrentPageReport]="true"
    [paginator]="true"
    [showFirstLastIcon]="false"
    [globalFilterFields]="globalFilterFields()"
    [value]="value()"
    (onFilter)="onTableFilter()">
    <ng-template pTemplate="caption">
      @if (additionalCaption) {
        <ng-container *ngTemplateOutlet="additionalCaption" />
      }

      <form [formGroup]="form()">
        <ui-table-header
          [placeholder]="headerPlaceholder()"
          [dropdownOptions]="headerDropdownOptions() ?? []" />
      </form>
    </ng-template>

    <ng-template pTemplate="body" let-rowData>
      @if (additionalBody) {
        <tr (click)="table.toggleRow(rowData)">
          <td>
            <div class="table__row" [class.table__row--clickable]="rowHover()">
              <div class="table__content">
                <ng-container
                  *ngTemplateOutlet="
                    additionalBody;
                    context: { $implicit: rowData }
                  " />
              </div>

              <div class="table__actions">
                @for (action of actions(); track $index) {
                  @if (!action.visible || action.visible(rowData)) {
                    <i
                      class="table__icon pi"
                      [ngClass]="action.iconName"
                      [pTooltip]="action.tooltip"
                      [tooltipPosition]="action.tooltipPosition"
                      (click)="
                        $event.stopPropagation(); action.action(rowData)
                      ">
                    </i>
                  }
                }
              </div>
            </div>
          </td>
        </tr>
      }
    </ng-template>

    @if (rowHover()) {
      <ng-template pTemplate="rowexpansion" let-rowData>
        @if (additionalExpansion) {
          <tr class="table__expansion">
            <td colspan="100%">
              <ng-container
                *ngTemplateOutlet="
                  additionalExpansion;
                  context: { $implicit: rowData }
                "></ng-container>
            </td>
          </tr>
        }
      </ng-template>
    }

    <ng-template pTemplate="emptymessage">
      <tr>
        <td>
          <div class="table__empty">
            @if (value().length === 0) {
              <span class="table__message">No data available.</span>
            }
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

@if (isPaginatorVisible()) {
  <ui-paginator
    [paginatorLabelSuffix]="paginatorLabelSuffix()"
    [table]="table"
    [value]="value()" />
}
